import React, { useEffect } from 'react';
import _ from 'underscore';
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles } from '@mui/styles';
import { Button, Card, CardContent, CardActions, Grid, Divider, TextField, colors, CardHeader } from '@mui/material';
import { SelectField } from 'components';
import DatePicker from 'components/DatePicker/DatePicker';
import validate from 'validate.js';

import { GenerateReport, SetFormState } from '../../actions/ReportPPMActions.js';

const useStyles = makeStyles((theme) => ({
	root: {
		padding: theme.spacing(3),
	},
	container: {
		marginTop: theme.spacing(3),
	},
	tabs: {
		marginTop: theme.spacing(3),
	},
	content: {
		marginTop: theme.spacing(3),
	},
	generate: {
		color: theme.palette.white,
		backgroundColor: colors.green[600],
		'&:hover': {
			backgroundColor: colors.green[900],
		},
	},
}));

const schema = {
	sitePPM: {
		presence: { allowEmpty: false, message: 'is required' },
	},
	reportTypePPM: {
		presence: { allowEmpty: false, message: 'is required' },
	},
	startDatePPM: {
		presence: { allowEmpty: false, message: 'is required' },
	},
	reportVendorPPM: {
		presence: { allowEmpty: false, message: 'is required' },
	}
};

const reportTypePPM = [
	{ value: 'hourly48', text: '48 Hours' },
	{ value: 'daily7', text: '7 Days' },
];

const reportVendorPPM = [
	{ value: 'Nokia', text: 'Nokia' },
	{ value: 'Ericsson', text: 'Ericsson' },
];

const ReportPPMForm = () => {
	const classes = useStyles();
	const dispatch = useDispatch();
	const setFormState = formState => dispatch(SetFormState(formState));
	const formState = useSelector((state) => state.reportPPMranReducer.formState);

	useEffect(() => {
		const errors = validate(formState.values, schema);

		setFormState({
			...formState,
			isValid: !errors,
			errors: errors || {},
		});
	}, [formState.values]);

	const _handleChangePPM = (event) => {
		setFormState({
			...formState,
			values: {
				...formState.values,
				[event.target.name]:
					event.target.type === 'checkbox'
						? event.target.checked
						: event.target.value,
			},
			touched: {
				...formState.touched,
				[event.target.name]: true,
			},
		});
	};

	const _handleDateChangePPM = (value, name) => {
		setFormState({
			...formState,
			values: {
				...formState.values,
				[name]: value,
			},
			touched: {
				...formState.touched,
				[name]: true,
			},
		});
	};

	const _hasError = (field) => (!!(formState.touched[field] && formState.errors[field]));
	const user = useSelector(state => state.session.user);
	const _generate = () => {
		dispatch(GenerateReport(formState.values.sitePPM, formState.values.reportTypePPM, formState.values.reportVendorPPM, formState.values.startDatePPM, user.id));
	};

	return (
		<Card className={classes.content}>
			<CardHeader title="Report PPM" />
			<Divider />
			<CardContent>
				<Grid container spacing={1}>
					<Grid item md={6} xs={6}>
						<TextField
							fullWidth
							label="Site(s) List"
							name="sitePPM"
							onChange={_handleChangePPM}
							value={formState.values.sitePPM}
							variant="outlined"
							error={_hasError('sitePPM')}
							helperText={
								_hasError('sitePPM') ? formState.errors.sitePPM[0] : 'Example: 10500,10501,10502'
							}
						/>
					</Grid>
					<Grid item md={2} xs={2}>
						<SelectField
							id="reportVendorPPM"
							name="reportVendorPPM"
							value={formState.values.reportVendorPPM || ''}
							onChange={_handleChangePPM}
							hintText="Vendor"
							menuItems={reportVendorPPM}
							error={_hasError('reportVendorPPM')}
							helperText={_hasError('reportVendorPPM') ? formState.errors.reportVendorPPM[0] : null}
						/>
					</Grid>
					<Grid item md={2} xs={2}>
						<SelectField
							id="reportTypePPM"
							name="reportTypePPM"
							value={formState.values.reportTypePPM || ''}
							onChange={_handleChangePPM}
							hintText="Type"
							menuItems={reportTypePPM}
							error={_hasError('reportTypePPM')}
							helperText={_hasError('reportTypePPM') ? formState.errors.reportTypePPM[0] : null}
						/>
					</Grid>
					<Grid item md={2} xs={2}>
						<DatePicker
							label="Activation Date"
							name="startDatePPM"
							value={formState.values.startDatePPM || null}
							onChange={(value) => _handleDateChangePPM(value, 'startDatePPM')}
							error={_hasError('startDatePPM')}
							helperText={_hasError('startDatePPM') ? formState.errors.startDatePPM[0] : null}
						/>
					</Grid>
				</Grid>
			</CardContent>
			<Divider />
			<CardActions>
				{/* <Button className={classes.generate} onClick={_generate} variant="contained" disabled={!formState.isValid}>Export</Button> */}
				<Button className={classes.generate} onClick={_generate} variant="contained">Export</Button>
			</CardActions>
		</Card>
	);
};

export default ReportPPMForm;
